import styled from "styled-components";

const SectionTitle = styled.h3`
  margin: 0;
  font-size: 14px;
`;

export default SectionTitle;